import * as FeatherIcons from "react-feather";
import { navSections } from "../../components/layout/navConfig";

const flatItems = navSections.flatMap((s) => s.items);

// react-feather export name for a navConfig icon component, found by
// reference equality against the same imported module navConfig itself
// uses to build its icon fields - reliable, no fragile displayName
// assumption. Falls back to "Star" if it's ever not found (shouldn't
// happen for anything actually in navConfig).
const iconNameFor = (IconComponent) =>
  Object.keys(FeatherIcons).find((name) => FeatherIcons[name] === IconComponent) || "Star";

// Only pages that already have a navConfig entry (the ~30 list/landing
// pages) can be pinned - detail/edit routes carry real IDs and have no
// stable label/icon to derive, so the "+" button just hides itself there
// rather than inventing a poor fallback label.
export const resolvePageMeta = (pathname) => {
  const match = flatItems.find((item) => item.path === pathname);
  if (!match) return null;
  return { label: match.label, iconName: iconNameFor(match.icon) };
};

export const iconComponentFor = (iconName) => FeatherIcons[iconName] || FeatherIcons.Star;
